import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { copyToClipboard } from 'src/app/core/utils/util';

@Component({
    selector: 'message-popover',
    templateUrl: './message-popover.component.html',
    imports: [CommonModule, TranslateModule, MatTooltipModule]
})
export class MessagePopoverComponent {
  //#region property
  @Input() fullText: string = '';
  @Input() title: string = '';
  @Input() isShowText: boolean = true;
  @Input() rightPopover: boolean = true;
  isVisible: boolean = false;
  elementRef = inject(ElementRef);

  //#endregion

  copyText() {
    copyToClipboard(this.fullText);
  }

  togglePopover() {
    this.isVisible = !this.isVisible;
  }

  closePopover() {
    this.elementRef?.nativeElement?.remove();
    this.isVisible = false;
  }
}
